export const createConfigSlice = (set, get) => ({
  config: {
    accessToken: null,
    color: "#3B82F6",
    textColor: "#111827",
    font: "",
    debug: false
  },
  configActions: {
    setConfig: (config) =>
      set((state) => { state.config = { ...state.config, ...config } }),
  },
});
